module.exports = __webpack_public_path__ + "static/img/zhangyong.34e5cbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teacher/zhangyong.png
// module id = ms3m
// module chunks = 2